/**
 * anlage-ballsets — Auswahl der Setgroessen-Kombination als zwei Karten.
 *
 * Kontrollierte Komponente: sie haelt keinen eigenen Zustand, `value` kommt von aussen.
 * Das ist hier nicht Geschmack, sondern noetig: bei einem Spielball ueberschreibt das
 * Backend die Wahl (`setKombination.erzwungen`), und die Seite setzt `value` danach
 * zurueck. Haette die Komponente ein eigenes Gedaechtnis, zeigte sie weiter die Wahl an,
 * die der Server gerade verworfen hat.
 *
 * Bedienung wie ein Radio-Set (`role="radiogroup"` + `aria-checked`), Optik als Karte —
 * ein echtes `<input type="radio">` laesst sich nicht so gross und ruhig gestalten.
 */
import type { SetKombinationKey } from '../typen';

interface Props {
  value: SetKombinationKey;
  onChange: (wert: SetKombinationKey) => void;
  /** Sperrt beide Karten (Spielball). Die erzwungene Wahl bleibt sichtbar markiert. */
  gesperrt?: boolean;
  /** Warum gesperrt ist — steht unter den Karten, damit niemand raten muss. */
  sperrGrund?: string;
}

const KARTEN: Array<{ key: SetKombinationKey; titel: string; erklaerung: string }> = [
  { key: 'fuenf-zehn', titel: '5 + 10 Bälle', erklaerung: 'Spielbälle' },
  { key: 'zehn-fuenfzehn', titel: '10 + 15 Bälle', erklaerung: 'Trainings-, Jugend- und Futsalbälle' },
];

export default function SetAuswahl({ value, onChange, gesperrt = false, sperrGrund }: Props) {
  return (
    <div>
      <span className="block text-sm font-medium text-[#1A1A1A]">Setgrößen</span>
      <div role="radiogroup" aria-label="Setgrößen-Kombination" className="mt-1 flex gap-2">
        {KARTEN.map((karte) => {
          const gewaehlt = karte.key === value;
          return (
            <button
              key={karte.key}
              type="button"
              role="radio"
              aria-checked={gewaehlt}
              disabled={gesperrt}
              onClick={() => onChange(karte.key)}
              className={`flex-1 rounded-lg border px-4 py-2.5 text-left transition-colors disabled:cursor-not-allowed disabled:opacity-60 ${
                gewaehlt
                  ? 'border-[#E9FF57] bg-[#E9FF57] text-[#1A1A1A]'
                  : 'border-[#DAD9D9] bg-white text-[#1A1A1A] hover:bg-gray-50'
              }`}
            >
              <span className="block text-sm font-semibold">{karte.titel}</span>
              <span className={`block text-xs ${gewaehlt ? 'text-[#1A1A1A]/70' : 'text-gray-500'}`}>
                {karte.erklaerung}
              </span>
            </button>
          );
        })}
      </div>
      {gesperrt && sperrGrund && <p className="mt-1.5 text-xs text-gray-600">{sperrGrund}</p>}
    </div>
  );
}
